import { z } from 'zod'
import { isFeatureId } from './model'

const StrictFeatureIdSchema = z.enum([
  'Feature:AccountExportAuditFields',
  'Feature:AccountTableBulkAction',
  'Feature:AskManager',
  'Feature:AvailabilityTask',
  'Feature:CalendarStackIdenticalEvents',
  'Feature:CalendarStrictCloserFlow',
  'Feature:CalendarEventUpsertAvailabilityCheck',
  'Feature:CanvassLayers',
  'Feature:CanvassQuickAddLocation',
  'Feature:CanvassQuickRecording',
  'Feature:CanvassProTrial',
  'Feature:CompetitionWidget',
  'Feature:Compliance',
  'Feature:Connect',
  'Feature:CustomFieldAllowMultiple',
  'Feature:CustomFieldPermissions',
  'Feature:CustomLocationManagement',
  'Feature:EmailAndPhoneData',
  'Feature:EnforceMaxUsers',
  'Feature:FilterOnlyAreaNesting',
  'Feature:ForcePasswordChange',
  'Feature:FromAccountStageOutcome',
  'Feature:ImportAreaDataPerBatch',
  'Feature:ImportIndexing',
  'Feature:ImportRetryTemporaryRows',
  'Feature:ImportRowLedgerShards',
  'Feature:ImportSerializeSameLocation',
  'Feature:Swift',
  'Feature:SwiftAnnouncement',
  'Feature:MaintenanceMode',
  'Feature:MaxPrescreenDistanceLimited',
  'Feature:MoveInData',
  'Feature:NotificationInbox',
  'Feature:PokeMode',
  'Feature:PurchaseFilters',
  'Feature:QuarterlyPlan',
  'Feature:Quiz',
  'Feature:RecordedConversations',
  'Feature:Recruitment',
  'Feature:RequireEntitlements',
  'Feature:ResidentScreenCustomFields',
  'Feature:SeparateSwiftVersionCheck',
  'Feature:SessionTopicThrottleRetry',
  'Feature:SingleUser',
  'Feature:SnapshotAreas',
  'Feature:TaskAssignment',
  'Feature:TeamHierarchyFocusView',
  'Feature:TerrosAIChat',
  'Feature:TerrosMCP',
  'Feature:Test',
  'Feature:TestMe',
  'Feature:VertexUsMultiRegion',
  'Feature:WindOverlaySimplify',
  'Feature:WorkflowHidePreviousActivity',
  'Feature:WorkflowMultiple',
  'Feature:WorkflowPreActions',
  'Feature:Workflows',
  'Feature:WorkflowsForCanvass',
  'Feature:WorkflowStats',
  'Feature:WorkflowTaskQueryV2',
  'Feature:WorkflowSetterCloserConfig',
  'Feature:WorkflowSetterCloserExecution',
  'Feature:NewLocationMatch',
  'Feature:AccountAddressOverride',
  'Feature:AccountUpsertPermissions',
  'Feature:AccountUpdateReassignPermission',
])

export type StrictFeatureId = z.infer<typeof StrictFeatureIdSchema>

const STRICT_FEATURE_IDS: ReadonlySet<string> = new Set(StrictFeatureIdSchema.options)

export const isStrictFeatureId = (value: unknown): value is StrictFeatureId =>
  isFeatureId(value) && STRICT_FEATURE_IDS.has(value)
